import cookie from 'js-cookie';
import getObj from './methods/getObj';
import setObj from './methods/setObj';

const PREFIX = {
  DEFAULT: 'hik_connect_pro_'
};

const NAME = {
  USER: `${PREFIX.DEFAULT }user`,
  PERMISSION: `${PREFIX.DEFAULT }permission`,
  ABILITY: `${PREFIX.DEFAULT }ability`,
  DOMAIN: `${PREFIX.DEFAULT }domain`,
  LOCALE: `${PREFIX.DEFAULT }locale`,
  LINKAGE_EXPIRES_TIP: `${PREFIX.DEFAULT }linkage_expires_tip`,
  AGREE_COOKIE: `${PREFIX.DEFAULT }agree_cookie`,
  ACCEPTED_COOKIE: `${PREFIX.DEFAULT }accepted_cookie_v2`, //需要全部用户重新同意cookie，因此对cookie的storage key进行更新
  NO_GLOBAL: `${PREFIX.DEFAULT }no_global`,
  TOURIST_MODE: `${PREFIX.DEFAULT }tourist_Mode`,
  ARC_HISTORY: `${PREFIX.DEFAULT }arc_history`,
  SELECT_COUNTRY: `${PREFIX.DEFAULT }country`,
  COMPANY: `${PREFIX.DEFAULT }company`,
  DICTIONARY: `${PREFIX.DEFAULT }dictionary`,
  USER_DB: `${PREFIX.DEFAULT }user_db`,
  COOKIE_DESCRIBE: `${PREFIX.DEFAULT }cookie-describe`,
  POINTS_TIPS: `${PREFIX.DEFAULT }points_tips`,
  TEACH_CENTER_NUM: `${PREFIX.DEFAULT }teach_center_num`,
  TEACH_CENTER_NUM_LOW: `${PREFIX.DEFAULT }teach_center_num_low`,
  TEACH_CENTER_CANCELED: `${PREFIX.DEFAULT }teach_center_canceled`,
  LAST_ONEHIKID_EMAIL: `${PREFIX.DEFAULT }last_oneHikId_email`,
  LAST_LOGIN_PHONE: `${PREFIX.DEFAULT }last_login_phone`,
  INSTALLER_SECOND_AUTH: `${PREFIX.DEFAULT }installer_second_auth`,
  INSTALLER_BATCH_SHARE_HC: `${PREFIX.DEFAULT }installer_batch_share_hc`,
  AREA_SUPPORT: `${PREFIX.DEFAULT }area_support`,
  EP_AUTH_LIST: `${PREFIX.DEFAULT }ep_auth_list`,
  GO_SUPPORT: `${PREFIX.DEFAULT }go_support`,
  SYMBOL: `${PREFIX.DEFAULT }symbol`,
  MANUAL_UPLOAD: `${PREFIX.DEFAULT }manual_upload`,
  LONGEST: `${PREFIX.DEFAULT }longest`,
  VERIFICATION_CODE: `${PREFIX.DEFAULT }verification_code`,
  CAN_AUTH_COUNTRY_LIST: `${PREFIX.DEFAULT }can_auth_country_list`
};

const USER_DATA_NAME = {
  LAN_BATCH_CONFIG_RED_POINT: 'lan_batch_point',
  ARC_ID_LIST_RED_POINT: 'arc_id_list_red_point',
  SITE_ARC_MAP: 'site_arc_map',
  SITE_SHARING_COLLAPSE: 'site_share_collapse',
  NO_REMINDER_NOTICE_LIST: 'no_reminder_notice_list',
  FLOW_4G_TIPS: 'flow_4g_tips',
  RELEASE_NOTE_TIPS: 'release_note_tips',
  WAHT_S_NEW_THUMBED: 'what_s_new_thumbed',
  HEALTH_MAINTORING_PACKAGE_TIPS: 'health_maintoring_package_tips',
  AC_DEFAULT_TIP_NOT: 'ac_default_tip',
  NO_NET_TIP_NOT: 'no_net_tip_not',
  ARC_DATA: 'arc_data'
};

//首页弹窗存储
const HOME_PAGE_POP_NAME = {
  HEALTH_MAINTORING_PACKAGE_POP: 'health_maintoring_package_pop', // new-maintenance-home-dialog.vue
  FOUR_G_FLOW_POP: 'four_g_flow_pop', // 4g-flow-tips.vue
  BI_MERGE_POP: 'bi_merge_pop', // bi-merge-tips.vue
  PRODUCT_UPGRADE_POP: 'product_upgrade_pop', // product-upgrade-pop.vue
  //   GIVE_PACKAGE_DIALOG: 'give_package_dialog', // give-package-dialog
  CO_BRANDING_TIPS: 'co_branding_tips', // co-branding-tips
  ARC_APPLICATION_TIPS: 'arc_application_tips', // arc-application-tips
  REMOTE_MAINTENANCE_PRO_PACKAGE_TIPS: 'remote_maintenance_pro_tip' // remote-maintenance-pro-tip
};

const COOKIE_NAME = {
  LOGIN: `${PREFIX.DEFAULT }login`
};

const WEBCONTROL_NAME = {
  UNFINSHEDUPGRADE: `${PREFIX.DEFAULT }unfinshed_upgrade`,
  MAINVERSION: `${PREFIX.DEFAULT }mainjs_version`
};

const HANDOVER_TEMPLATE_NAME = {
  PERM_MULTI_LANG_MAP: 'permMultiLangMap',
  PERM_SHARE_PRIVACY: 'permSharePrivacy'
};

const STORAGE_KEY = `${PREFIX.DEFAULT }data`;

function getStorages() {
  let data = localStorage.getItem(STORAGE_KEY) || '';
  if (data) {
    data = JSON.parse(data);
  }
  return new Map(data);
}

let storages = getStorages();

function setStorages(map) {
  let str = JSON.stringify([...map]);
  localStorage.setItem(STORAGE_KEY, str);
}

const listeners = {};

const SITE_INDEX_TAB = {
  NAME: 'SITE_INDEX_TAB',
  SITE: '1',
  DEVICE: '2',
  DEVICE_STATE: '3'
};

const SITE_INDEX_DEVICE = {
  NAME: 'SITE_INDEX_DEVICE',
  EXCEPTION: '1',
  NORMAL: '2'
};

const DEVICE_INDEX_MODE = {
  NAME: 'DEVICE_INDEX_MODE',
  PERMISSION: '2',
  EXCEPTION: '1',
  NORMAL: '0'
};


export default {
  setObj,
  getObj,
  setLongestStore(key, val) {
    // 设置长久保存的字段，适用于引导弹窗
    const db = localStorage.getItem(NAME.LONGEST) ? JSON.parse(localStorage.getItem(NAME.LONGEST)) : {};
    db[key] = val;
    localStorage.setItem(NAME.LONGEST, JSON.stringify(db));
  },
  getLongestStore(key) {
    const db = localStorage.getItem(NAME.LONGEST) ? JSON.parse(localStorage.getItem(NAME.LONGEST)) : {};
    if (db) {
      return db[key];
    }
    return null;
  },
  // 首页弹窗取/赋值专用
  setHomePagePopStore(page) {
    let arr = this.getLongestStore('HOME_PAGE_POP_NAME') || [];
    arr.push(page);
    this.setLongestStore('HOME_PAGE_POP_NAME', arr);
  },
  getHomePagePopStore(page) {
    return (
      this.getLongestStore('HOME_PAGE_POP_NAME')
      && this.getLongestStore('HOME_PAGE_POP_NAME').length
      && this.getLongestStore('HOME_PAGE_POP_NAME').includes(page)
    );
  },
  realGet(key) {
    return localStorage.getItem(key);
  },

  realSet(key, val) {
    localStorage.setItem(key, val);
  },

  realDel(key, val) {
    localStorage.removeItem(key, val);
  },

  realGetByUser(key) {
    const db = localStorage.getItem(NAME.USER_DB) ? JSON.parse(localStorage.getItem(NAME.USER_DB)) : {};
    const installerId = getStorages().get(NAME.USER) ? getStorages().get(NAME.USER).data.installerId : '-1';
    const installerData = db[installerId];
    if (installerData) {
      return installerData[key];
    }
    return null;
  },

  // 异步获取值，特殊情况下使用
  realGetByUserAsync(key) {
    return new Promise((resolve) => {
      const val = this.realGetByUser(key);
      // eslint-disable-next-line no-undefined
      if (val === undefined || val === null) {
        listeners[key] = listeners[key] || [];
        listeners[key].push(resolve);
      } else {
        resolve(val);
      }
    });
  },

  realSetByUser(key, val, cusId) {
    const db = localStorage.getItem(NAME.USER_DB) ? JSON.parse(localStorage.getItem(NAME.USER_DB)) : {};
    let installerId = getStorages().get(NAME.USER) ? getStorages().get(NAME.USER).data.installerId : '-1';
    if (cusId) {
      installerId = cusId;
    }
    let installerData = db[installerId] || {};
    installerData[key] = val;
    db[installerId] = installerData;
    localStorage.setItem(NAME.USER_DB, JSON.stringify(db));

    if (listeners[key]) {
      let fn = listeners[key].shift();
      while (fn) {
        fn(val);
        fn = listeners[key].shift();
      }
    }
  },

  realDelByUser() {
    const db = localStorage.getItem(NAME.USER_DB) ? JSON.parse(localStorage.getItem(NAME.USER_DB)) : {};
    const installerId = getStorages().get(NAME.USER) ? getStorages().get(NAME.USER).data.installerId : '-1';
    delete db[installerId];
    localStorage.setItem(NAME.USER_DB, JSON.stringify(db));
  },

  realRemoveByUser(val) {
    const db = localStorage.getItem(NAME.USER_DB) ? JSON.parse(localStorage.getItem(NAME.USER_DB)) : {};
    const installerId = getStorages().get(NAME.USER) ? getStorages().get(NAME.USER).data.installerId : '-1';
    if (!db[installerId]) {
      return;
    }
    if (db[installerId][val]) {
      delete db[installerId][val];
    }
    localStorage.setItem(NAME.USER_DB, JSON.stringify(db));
  },

  set(key, data) {
    storages.set(key, {
      key: key,
      data: data
    });
    setStorages(storages);
  },

  setLogin(session) {
    if (session) {
      cookie.set(COOKIE_NAME.LOGIN, session);
    }
  },

  get(key) {
    let data = '';
    storages = getStorages();
    if (storages.has(key)) {
      data = storages.get(key).data;
    }
    return data;
  },

  delete(key) {
    storages.delete(key);
    setStorages(storages);
  },

  clear() {
    storages.clear();
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem('order-dont-remind-aging-stock'); //EP开发要求额外删除的key，不写在公共内容中
    localStorage.removeItem('order-dont-remind-smart-try');
    for (let x in COOKIE_NAME) {
      cookie.remove(COOKIE_NAME[x]);
    }
  },

  NAME,
  USER_DATA_NAME,
  WEBCONTROL_NAME,
  HOME_PAGE_POP_NAME,
  HANDOVER_TEMPLATE_NAME,
  SITE_INDEX_TAB,
  SITE_INDEX_DEVICE,
  DEVICE_INDEX_MODE
};
